import axios, { AxiosError } from 'axios';
import { ErrorMessageKey, errorMessages } from './errorMessages';

interface ErrorDataDefault {
  code: string;
  message: string;
}
const defaultErrorMessage = 'Request to server fail, please try again later!';

export const httpErrorHandler = (error: AxiosError | Error): string => {
  if (axios.isAxiosError(error)) {
    const response = error?.response;
    const request = error?.request;

    if (response) {
      const statusCode = response?.status;
      const errorData = response.data as ErrorDataDefault | string[];

      if (statusCode === 500) {
        return 'Something went wrong, please try again later!';
      }
      if (statusCode === 403) {
        return 'You do not have permissions to access this resource';
      }

      if (Array.isArray(errorData)) {
        const errorCode = errorData[0] as ErrorMessageKey;

        return errorMessages[errorCode] || defaultErrorMessage;
      } else if (typeof errorData === 'object' && 'message' in errorData) {
        return (errorData as ErrorDataDefault).message;
      }
    } else if (request) {
      return 'The request was made but no response was received';
    }
  }

  return defaultErrorMessage;
};
